export const METHODOLOGY_PAGE_CONTENT = {
    title: 'Главные преимущества нашего каталога для пользователей&nbsp;&mdash; объективность и&nbsp;экспертность',
    body: [
        { type: 'header', data: { text: 'Объективность', level: 3 } },
        {
            type: 'paragraph',
            data: {
                text: 'проявляется в&nbsp;том, что описание каждой франшизы создается по&nbsp;единым стандартам. Перечень параметров зафиксирован, и&nbsp;компании не&nbsp;смогут умолчать, например, о&nbsp;том, на&nbsp;какую ежемесячную прибыль должен ориентироваться франчайзи и&nbsp;как производился подсчет. Многие каталоги вынуждают пользователей запрашивать недостающие показатели, искусственно повышая лидогенерацию, но&nbsp;мы&nbsp;собираем для вас максимально полную картину по&nbsp;франшизам.',
            },
        },
        { type: 'paragraph', data: { text: 'Из&nbsp;каких разделов состоит карточка франшизы у&nbsp;нас на&nbsp;сайте:' } },
        {
            type: 'list',
            data: {
                items: [
                    'Основные параметры франшизы (больше 10&nbsp;показателей, в&nbsp;том числе общая сумма инвестиций для запуска, ежемесячные расходы, ежемесячные выручка и&nbsp;чистая прибыль, срок окупаемости, годовой ROI&nbsp;&mdash; чистая прибыль к&nbsp;объему инвестиций, год запуска, количество действующих франчайзи, а&nbsp;также собственных и&nbsp;франчайзинговых точек на&nbsp;1&nbsp;января текущего календарного года; показатели сопровождаются дисклеймером о&nbsp;том, как они были получены&nbsp;&mdash; например, может использоваться средний показатель по&nbsp;всем франчайзи в&nbsp;последнем отчетном году);',
                    'Расшифровка затрат франчайзи (из&nbsp;каких расходов складывается общая сумма инвестиций и&nbsp;сумма ежемесячных расходов, за&nbsp;что именно взимаются паушальный взнос и&nbsp;роялти);',
                    'Содержание франчайзингового пакета;',
                    'Этапы открытия бизнеса по&nbsp;франшизе;',
                    'Результаты проверки по&nbsp;методологии Forbes;',
                    'История компании-франчайзера;',
                    'Отзывы франчайзи',
                ],
            },
        },
        { type: 'header', data: { text: 'Экспертность', level: 3 } },
        {
            type: 'paragraph',
            data: {
                text: 'нашего каталога заключается в&nbsp;проверке франшиз перед публикацией карточек по&nbsp;собственной методолгии Forbes. Она основана на&nbsp;оценке четырех аспектов:',
            },
        },
        {
            type: 'list',
            data: {
                items: [
                    'устойчивости&nbsp;&mdash; оценивается срок присутствия на&nbsp;рынке, финансовое положение и&nbsp;судебная история;',
                    'ценности&nbsp;&mdash; рассматривается содержание типового соглашения и&nbsp;франчбука, список передаваемых прав и&nbsp;технологий;',
                    'потенциала&nbsp;&mdash; анализируются доходность и&nbsp;срок окупаемости, перспективность ниши;',
                    'сервиса&nbsp;&mdash; принимается в&nbsp;расчет количество действующих франчайзи и&nbsp;их&nbsp;удовлетворенность.',
                ],
            },
        },
        {
            type: 'paragraph',
            data: {
                text: 'Чек-лист проверки включает несколько десятков вопросов, ответы на которые дают возможность составить описания франшиз по единым стандартам, чтобы покупатели могли объективно оценить плюсы от будущего партнерства. Мы&nbsp;используем доступные нам базы данных и&nbsp;открытые источники для того, чтобы подтвердить часть ответов в&nbsp;анкете.',
            },
        },
        {
            type: 'paragraph',
            data: {
                text: 'Каталог предусматривает возможность отфильтровать предложения по виду деятельности, географии (по численности населения города, на который может быть предоставлена франшиза), размеру стартовых инвестиций, сроку окупаемости, ежемесячному доходу и другим признакам.<br>Внутри как общего, так и отфильтрованного списка франшиз можно сделать сортировку предложений по новизне (в начале списка окажутся франшизы, добавленные в каталог последними), популярности (сверзу — с наибольшим числом просмотров карточки за последние 30 дней), доступности (сверху — с минимальными стартовыми инвестициями), окупаемости (сверху —с минимальным сроком окупаемости) и доходности (сверху — с максимальной ежемесячной прибылью)',
            },
        },
    ],
};
export const OFFER_PAGE_CONTENT = [
    {
        title: 'Расскажите о своей франшизе',
        texts: [
            'Если вашей франшизе больше 3&nbsp;лет, вы&nbsp;можете подать заявку на&nbsp;размещение в&nbsp;каталоге Forbes.',
            'Для амбициозных компаний мы&nbsp;подготовили пакетные предложения, позволяющие значительно усилить позиционирование на&nbsp;рынке с&nbsp;помощью размещения различных нативных интеграций в&nbsp;профессиональном контенте, что позволит значительно усилить узнаваемость бренда и&nbsp;привлечь внимание целевой аудитории именно к&nbsp;вашей франшизе.',
        ],
    },
];
export const ABOUT_PAGE_CONTENT = [
    {
        summary: 'Что включает в себя проект «Forbes Франшизы»?',
        body: [
            {
                type: 'list',
                data: {
                    items: [
                        '<a href="https://www.forbes.ru/franchises/catalog?type_sort=new">Каталог</a> франшиз, проверенных по собственной методологии Forbes;',
                        'Редакционный контент — кейсы компаний, обзоры, HowTo-тексты;',
                        'Раздел на основном сайте Forbes Russia — <a href="/franshises">«Forbes Франшизы»</a>. Попасть в раздел можно будет из главного меню Forbes.ru;',
                        'Тематические каналы в Telegram <a href="https://t.me/forbesfranchises" target="_blank" rel="noopener noreferer nofollow">TG</a> и соцсетях <a href="https://vk.com/forbesfranchises" target="_blank" rel="noopener noreferer nofollow">VK</a>;',
                        'Ежегодный журнал «Forbes Франшизы», от 120 страниц;',
                        'Ежегодный <a href="https://www.youtube.com/watch?v=SiewRBjZupw" target="_blank" rel="noopener noreferer nofollow">фильм</a> «Франшизы» на главном YouTube-канале Forbes Russia, от 1 часа',
                    ],
                },
            },
        ],
    },
    {
        summary: 'Зачем нужен еще один каталог, ведь на рынке их много?',
        body: [
            {
                type: 'paragraph',
                data: {
                    text: 'Каждый год редакция Forbes Russia публикует <a href="https://www.forbes.ru/biznes/491338-30-samyh-vygodnyh-fransiz-v-rossii-2023-rejting-forbes?ysclid=lxizcxiw6s69987681">рейтинг «30 самых выгодных франшиз»</a>. Достойные предложения выбираются в трех категориях — с инвестициями до 2 млн рублей, от 2 до 5 млн и свыше 5 млн. Опыт формирования рейтинга показал, что есть спрос на расширенный список добросовестных франчайзеров.<br> На рынок ежегодно выходит несколько сотен новых предложений, при этом 80% покупателей франшиз разочаровываются — получают убытки или доход ниже ожидаемого. Крупнейшие каталоги франшиз работают как площадки для рекламных объявлений, они создают продающие страницы для любого предложения, а проверку франшиз часто предлагают в виде дополнительной услуги.<br> При всем разнообразии каталогов на рынке до сих пор не появилось крупной площадки, которая бы проводила предварительную проверку франшиз и создавала визитки для них по единым стандартам, чтобы покупатели лучше ориентировались в потоке предложений. <br>Для многих товаров, представленных на маркетплейсах Wildberries и Ozon, стала обязательной маркировка в системе «Честный знак». Нам кажется важным, чтобы свой «Честный знак» появился и на рынке франчайзинга, где так важна репутация и транспарентность. И мы верим, что присутствие в каталоге «Forbes Франшизы» станет именно таким «Честным знаком» для игроков этого бурно развивающегося рынка»',
                },
            },
        ],
    },
    {
        summary: 'У других каталогов тоже есть «надежные» и «проверенные» франшизы, в чем уникальность нашей проверки?',
        body: [
            {
                type: 'paragraph',
                data: {
                    text: 'Для проведения качественной проверки большого количества предложений необходима экспертиза и ресурсы, которые есть не у всех. Иногда в каталогах можно отфильтровать предложения, которые существуют на рынке несколько лет или подтвердили регистрацию своего товарного знака в Роспатенте, но, конечно, этого недостаточно.<br>Наша методология проверки основана на оценке четырех аспектов:',
                },
            },
            {
                type: 'list',
                data: {
                    items: [
                        'устойчивости — оценивается срок присутствия на рынке, финансовое положение и судебная история;',
                        'ценности — рассматривается содержание типового соглашения и франчбука, список передаваемых прав и технологий;',
                        'потенциала — анализируются доходность и срок окупаемости, перспективность ниши;',
                        'сервиса — принимается в расчет количество действующих франчайзи и их удовлетворенность.',
                    ],
                },
            },
            {
                type: 'paragraph',
                data: {
                    text: 'Чек-лист проверки включает несколько десятков вопросов, ответы на которые дают возможность составить описания франшиз по единым стандартам, чтобы покупатели могли объективно оценить плюсы от будущего партнерства',
                },
            },
        ],
    },
    { isFranchisePromo: true },
    {
        summary: 'Почему мы нужны продавцам франшиз?',
        body: [
            {
                type: 'paragraph',
                data: {
                    text: 'Раздел «Forbes Франшизы», включающий каталог, размещен на сайте Forbes.ru. Forbes — самое известное и авторитетное финансово-экономическое медиа в мире, сайт российской версии журнала ежемесячно посещают 9 млн уникальных пользователей. На аккаунты Forbes Russia в соцсетях и YouTube подписались 6 млн человек. Примерно 30% нашей аудитории владеют бизнесом, еще 30% — руководители среднего и высшего звена',
                },
            },
            {
                type: 'list',
                data: {
                    items: [
                        'Вы расскажете о своей франшизе большой профильной аудитории',
                        'Повысите доверие к вашей франшизе, прошедшей проверку Forbes',
                        'Усилите свои позиции в поисковой выдаче и цитируемость благодаря медийному весу Forbes',
                        'Увеличите интерес читателей к вашей компании с помощью нативного контента от профессиональной редакции',
                        'Получите возможность дополнительного продвижения в Telegram-каналах и соцсетях',
                        'Сможете оперативно подать заявку на участие в ежегодном рейтинге самых выгодных франшиз',
                    ],
                },
            },
        ],
    },
    {
        summary: 'Почему мы нужны потенциальным покупателям франшиз?',
        body: [
            {
                type: 'paragraph',
                data: {
                    text: 'Самое главное — вы сможете выбирать франшизу из списка предложений, прошедших предварительную проверку Forbes. Это не значит, что будете полностью застрахованы от потери денег, ведь бизнес по франшизе — это тоже предпринимательство, и риски в такой деятельности неизбежны. Но вам не придется тратить время на сомнительные предложения. Кроме того, наша методология предполагает подсветку сильных и слабых сторон франшизы — это бесплатная экспертиза, которой мы делимся со своими читателями.<br> Вы получите бесплатный доступ к профессиональному контенту о франчайзинге — успешным и провальным кейсам франчайзи, советам опытных покупателей франшиз и консультантов, обзорам сегментов рынка, прогнозам, инструкциям по решению отдельных вопросов. Экспертиза и объективный взгляд на события — наше преимущество, ведь мы работаем по журналистским стандартам Forbes.<br> У вас появится возможность задать нам свои вопросы и даже стать героями будущих публикаций. Мы собираемся развивать комьюнити вокруг «Forbes Франшизы» и будем рады обратной связи! Пока предлагаем присоединиться к нам онлайн — подписывайтесь и оставляйте свои комментарии в нашем Telegram-канале (<a href="https://t.me/forbesfranchises" target="_blank" rel="noopener noreferer nofollow">TG</a>) и соцсетях (<a href="https://vk.com/forbesfranchises" target="_blank" rel="noopener noreferer nofollow">VK</a>)',
                },
            },
        ],
    },
    {
        summary: 'На чем основана наша тарифная политика?',
        body: [
            {
                type: 'paragraph',
                data: {
                    text: 'Участие в каталоге является платным для франчайзеров — это даст нам возможность проводить качественную проверку франшиз и поддерживать базу предложений в актуальном состоянии. <br> Мы позаботились о том, чтобы наши <a href="/franchises/offer/">тарифы</a> были одними из самых доступных на рынке: например, проверка франшизы, создание для нее отдельной страницы на сайте Forbes и размещение в каталоге в течение шести месяцев будет стоить 90 тыс. рублей.<br>Для амбициозных компаний мы подготовили пакетные предложения, позволяющие значительно усилить позиционирование на рынке и цитируемость благодаря медийному весу Forbes. С помощью нативного контента от профессиональной редакции — интервью, статей и видео — вы сможете повысить интерес аудитории именно к вашей компании.<br> Приятный бонус: компаниям, вошедшим в наш ежегодный рейтинг франшиз, будет предоставлена возможность бесплатного размещения в каталоге в течение трех месяцев в дополнение к вабранному тарифу',
                },
            },
        ],
    },
    {
        summary: 'Как попасть в каталог «Forbes Франшизы»?',
        body: [
            {
                type: 'paragraph',
                data: {
                    text: 'Вы можете предложить свою франшизу для размещения в каталоге Forbes, если она существует на рынке дольше трех лет. Для этого вам потребуется:',
                },
            },
            {
                type: 'list',
                data: {
                    items: [
                        'Выбрать один из <a href="/franchises/offer">тарифов</a> и <a href="/franchises/offer">отправить заявку</a>, чтобы наши менеджеры могли связаться с вами',
                        'Заполнить по своей франшизе присланную нами анкету, предоставить дополнительную информацию по запросу',
                        'После проверки франшизы и одобрения заявки — оплатить выбранный тариф',
                        'Согласовать тексты, фото и видеоматериалы, которые будут размещены на странице вашей франшизы',
                        'Оставаться на связи с аккаунт-менеджером для внесения изменений на страницу и решения других вопросов',
                    ],
                },
            },
        ],
    },
];
/**
 * Data for promo call to action
 */
export const FRANCHISE_PROMO_CTA = {
    title: 'Предложить франшизу',
    text: 'Разместите информацию о своей франшизе в каталоге Forbes',
    buttonText: 'Оставить заявку',
    to: '/franchises/offer',
};
export const OFFER_METRIKA_ID = '103240088';
